module.exports = __webpack_public_path__ + "static/media/Facebook.c5ecd2ab.png";